export default "__VITE_ASSET__Dw4uIj_W__"